// extracted by mini-css-extract-plugin
module.exports = {"box1":"SocialBlock_box1__1gBDr","box2":"SocialBlock_box2__NGBh4","name":"SocialBlock_name__3A6Lk","icon":"SocialBlock_icon__1Vei8"};